import { FC } from "react";

interface MediaItemProps {
  link: string;
  label: string;
  img_src: string;
  main_img?: string;
  date: string;
}

const MediaItem: FC<MediaItemProps> = ({
  link,
  label,
  img_src,
  main_img,
  date,
}) => {
  return (
    <a
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      className="border-grey-300 flex w-full flex-col items-start gap-5 overflow-hidden rounded-[20px] border bg-white transition-shadow duration-300 hover:shadow-lg"
    >
      <div className="relative flex h-[240px] w-full shrink-0 items-center justify-center overflow-hidden bg-[#ececec]">
        {main_img && (
          <img
            alt={label}
            className="h-full w-full object-cover"
            src={main_img}
          />
        )}
      </div>
      <div className="flex w-full shrink-0 flex-col items-start gap-3 px-5 pb-5 text-start">
        <div className="flex h-[42px] w-full items-center justify-between">
          <img
            alt={label}
            className="max-h-full max-w-[120px] object-contain object-left"
            src={img_src}
          />
          <p className="text-muted overflow-hidden text-sm font-light text-ellipsis">
            {date}
          </p>
        </div>
        <div className="flex w-full flex-col items-start gap-2">
          <p className="text-dark text-[24px] leading-[1.2] font-medium whitespace-pre-wrap">
            {label}
          </p>
        </div>
      </div>
    </a>
  );
};

export default MediaItem;
